<template>
    <div data-test-view="goals-cycles-list">
        <l-card-content>
            <!-- Headline -->
            <l-headline :title="$t(`goals.cycle.list.title`)" :tabs="tabs" />
            <!--/Headline -->

            <!-- List -->
            <div v-if="cycles.length">
                <div v-for="cycle in cycles" :key="cycle._id">
                    <l-goal-cycle-list-item :cycle="cycle" />
                </div>
            </div>
            <!--/List -->

            <!-- No Data -->
            <l-no-data
                v-else
                :icon="iconNoData"
                :text="$t(`goals.cycle.list.listEmptyH1`)"
                :btn-show="rights.G_CYCLE_ADMIN"
                :btn-text="$t(`goals.cycle.list.listEmptyH2`)"
                :btn-handler="createGoalCycle"
                data-test-id="goals-cycle-list-no-data"
            />
            <!--/No Data -->
        </l-card-content>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LCardContent from "@/components/LCardContent";
import LHeadline from "@/components/LHeadline";
import LGoalCycleListItem from "@/components/LGoalCycleListItem";
import LNoData from "@/components/LNoData";

import iconNoData from "@/img/icons/nodata.png";

export default {
    components: {
        LCardContent,
        LHeadline,
        LGoalCycleListItem,
        LNoData,
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
            cycles: "goals/cycles/sortedList",
        }),
        tabs() {
            return [
                {
                    show: true,
                    label: this.$t(`goals.cycle.list.subTitle`),
                    icon: "fal fa-external-link",
                    iconBeforeLabel: true,
                    tabClass: "descriptive",
                    handler() {
                        window.open(
                            `https://leapsome.zendesk.com/hc/en-us/articles/360003224378-How-to-manage-goal-cycles`,
                            "_blank",
                            "noopener noreferrer",
                        );
                    },
                },
                { show: true, tabClass: "space" },
                {
                    label: this.$t(`goals.cycle.list.btnCreate`),
                    show: this.rights.G_CYCLE_ADMIN,
                    handler: this.createGoalCycle,
                    isButton: true,
                    tabClass: "btn-primary",
                    testId: "goals-cycle-create",
                },
            ];
        },
    },
    created() {
        this.iconNoData = iconNoData;
    },
    methods: {
        createGoalCycle() {
            this.$router.push(`/goals/cycles/create`);
        },
    },
};
</script>

<style scoped></style>
